import styled from 'styled-components';
import Card from 'components/common/Card';

export const PaddingTop = styled.div`
  padding-top: 8px;
`;

export const Padding = styled.div`
  padding: 24px;
`;

export const CardDisplay = styled(Card.Content)``;

export const Container = styled.div`
  display: flex;
  flex: 1;
  max-width: 1600px;
  justify-content: center;
  margin-top: calc(88px + 24px);
`;
